export const SIDEBAR_WIDTH = 256;
export const SIDEBAR_WIDTH_DENSED = 236;
export const TOP_BAR_HEIGHT = 64;

export const OPEN_SIDEBAR_WIDTH = 256;
export const CLOSE_SIDEBAR_WIDTH = 100;
